/** SPEC §18.2: @vermeldingen in opmerkingen, opgeslagen als @[Naam](gebruiker-id). */
const PATROON = /@\[([^\]\n]{1,80})\]\(([A-Za-z0-9-]{1,64})\)/g;

export function vermeldingenIn(tekst: string): string[] {
  return [...new Set([...tekst.matchAll(PATROON)].map((m) => m[2]))];
}

export type TekstDeel = { soort: 'tekst'; tekst: string } | { soort: 'vermelding'; naam: string; id: string } | { soort: 'link'; url: string };

/** Tekst opdelen in gewone tekst, vermeldingen en links (voor veilig tonen zonder HTML). */
export function tekstDelen(tekst: string): TekstDeel[] {
  const uit: TekstDeel[] = [];
  const re = /@\[([^\]\n]{1,80})\]\(([A-Za-z0-9-]{1,64})\)|(https?:\/\/[^\s<>"]+[^\s<>".,;:!?)\]])/g;
  let i = 0;
  for (const m of tekst.matchAll(re)) {
    if (m.index! > i) uit.push({ soort: 'tekst', tekst: tekst.slice(i, m.index) });
    if (m[1]) uit.push({ soort: 'vermelding', naam: m[1], id: m[2] });
    else uit.push({ soort: 'link', url: m[3] });
    i = m.index! + m[0].length;
  }
  if (i < tekst.length) uit.push({ soort: 'tekst', tekst: tekst.slice(i) });
  return uit;
}

/** Platte tekst (voor mails en meldingen): @[Naam](id) → @Naam */
export const platteTekst = (tekst: string) => tekst.replace(PATROON, '@$1');
